import { MessageResponseDto } from "@api/api";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { couponFormDefault } from "@factory/form/form.default";
import { CouponFormRule, CouponFormSchema } from "@factory/form/form.rule";
import { useQyCreateCoupon } from "@factory/query/coupon.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewCoupon() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { getUserRole } = useUserIdentityContext();
  const { mapCreateCoupon } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Coupon is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addCoupon, isLoading: isCreating } =
    useQyCreateCoupon(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<CouponFormSchema>({
    defaultValues: couponFormDefault,
    resolver: zodResolver(CouponFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: CouponFormSchema) => {
    const { tenant } = getUserRole();
    const updatedForm = {
      ...form,
      tenant
    } as CouponFormSchema;
    const formData = mapCreateCoupon(updatedForm);
    addCoupon(formData);
  };
  const handleValidateError = (err: FieldErrors<CouponFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
